import Box from '@mui/material/Box'
import {useEffect} from 'react'
import {useIframeWrapper} from '../../../../styles/useStyles'
import AppBar from '../header/AppBar'

export default function DemoSignup({src}: {src: string}) {
  const classes = useIframeWrapper()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <Box>
      <AppBar />

      <div className={classes.container}>
        <iframe src={src} width='640' height='2000' className={classes.resonsiveIframe}>
          Loading…
        </iframe>
      </div>
    </Box>
  )
}
